import { API_AUTH } from "./common";

const PhiKhacApi = {
  list: ({ type }) =>
    API_AUTH.get(`quan-ly-cho-vay/phi-cho-vay?typeChoVay=${type}`, {}),

  listTheoChoVay: ({ chovayId, typeChoVay }) =>
    API_AUTH.get(
      `quan-ly-cho-vay/phi-cho-vay-theo-cho-vay?chovayId=${chovayId}&typeChoVay=${typeChoVay}`,
      {}
    ),

    listTheoChoVay1: ( chovayId, typeChoVay ) =>
    API_AUTH.get(
      `quan-ly-cho-vay/phi-cho-vay-theo-cho-vay?chovayId=${chovayId}&typeChoVay=${typeChoVay}`,
      {}
    ),
};

export default PhiKhacApi;
